export default __webpack_public_path__ + "static/media/user.d6a1cbd9.svg";